import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchFeaturedWork = async () => {
  const { data } = await axios.get(`${API}/work`, { params: { featured: true } });
  return data;
};

export const fetchAllWork = async () => {
  const { data } = await axios.get(`${API}/work`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};
